import styled from 'styled-components'

export const Step3BNotHoldWrapper = styled.div`
  padding-bottom: 24px;
`